export default __webpack_public_path__ + "static/media/OGDC.e4df3d46.png";